export default "__VITE_ASSET__CeMUzWy$__"